// extracted by mini-css-extract-plugin
export default {"smart-banner-spacer":"styles__smart-banner-spacer--1idfX","smart-banner-fix":"styles__smart-banner-fix---NboM"};